<template>
  <div>
    <component v-bind:is="imgComponent" v-bind:reportDetail.sync="reportDetail">
    </component>
  </div>
</template>

<script>
const img_map = new Map([
  [true, { component: 'reportFoundPictureVue' }],
  [false, { component: 'reportFoundSwiperVue' }]
]);
import reportFoundPictureVue from './report-found-picture.vue';
import reportFoundSwiperVue from './report-found-swiper.vue';
export default {
  props: {
    reportDetail: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean
    }
  },
  components: {
    reportFoundPictureVue,
    reportFoundSwiperVue
  },
  computed: {
    imgComponent() {
      const { component } = img_map.get(this.visibleEdit);
      return component;
    }
  }
};
</script>

<style lang="scss"></style>
